export const COLORS = {
  primary: '#2896f6',
  secondary: '#44d1d5',
  lightDark: '#171f22',
  black: '#000000',
  darkBlue: '#021529',
  white: '#FFFFFF',
};

export const SIZES = {
  padding: '24px',
  margin: '24px',
};

export const TYPOGRAPHY_SIZES = {
  H1: '32px',
  H2: '28px',
  H3: '26px',
  H4: '24px',
  H5: '22px',
  H6: '20px',
  H7: '18px',
  BIG: '16px',
  NORMAL: '14px',
  SMALL: '12px',
};
